export default function generateMetaImage (siteOptions, page) {
  if (siteOptions.default_og_image) {
    let image = siteOptions.default_og_image.sizes['friwi_social-share-large']

    if (page.og_enabled) {
      page.og_image ? image = page.og_image.sizes['friwi_social-share-large'] : null
    }

    return image
  }
}



// WEBPACK FOOTER //
// ./client/common/generateMetaImage.js